
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $b5777601b32f5d7f$exports = {};

$parcel$export($b5777601b32f5d7f$exports, "spectrum--darkest", function () { return $b5777601b32f5d7f$export$4ecdba604f5f1f44; }, function (v) { return $b5777601b32f5d7f$export$4ecdba604f5f1f44 = v; });
var $b5777601b32f5d7f$export$4ecdba604f5f1f44;
$b5777601b32f5d7f$export$4ecdba604f5f1f44 = `R-l9gW_spectrum--darkest`;


export {$b5777601b32f5d7f$exports as default};
//# sourceMappingURL=vars_spectrum-darkest_css.mjs.map
